/*
 * Veloura Dolls – kompakter Cookie-Banner (eigener Banner, 14.10.2026)
 * ---------------------------------------------------------------------
 * - Liest die Konfiguration aus <script type="application/json" id="vd-cookie-config"> (Snippet vd-cookie-banner).
 * - Speichert die Wahl ausschliesslich über die Shopify Customer Privacy API
 *   (Shopify.customerPrivacy.setTrackingConsent) -> Shopify-Pixel, Custom Pixel «VD Analyse intern»
 *   und die App «Google & YouTube» (Consent Mode) richten sich danach.
 * - Zeigt den Banner nur, wenn Shopify es verlangt (shouldShowBanner) – also in den Regionen,
 *   die im Admin unter «Kundendatenschutz → Cookie-Banner → eigene Banner-Regionen» eingetragen sind.
 * - EU/EWR/UK (inkl. Liechtenstein!): zusätzlicher gleichwertiger Button «Nur notwendige» (Theme-Einstellung).
 * - Öffnet die Einstellungen auch über den Shopify-Link #shopifyReshowConsentBanner in der Fusszeile.
 * - Test-Schalter per URL (nur Anzeige, speichert nichts): ?vd_cookie=show | ch | eu | prefs
 * Keine Abhängigkeiten, ES5-kompatibel.
 */
(function () {
  'use strict';
  if (window.__vdCookieBanner) return;
  window.__vdCookieBanner = true;

  var cfgEl = document.getElementById('vd-cookie-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* EU-27 + EWR (IS, LI, NO) + Vereinigtes Königreich: Ablehnen muss gleich einfach sein wie Akzeptieren */
  var STRICT = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT',
    'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'IS', 'LI', 'NO', 'GB'];

  var T = C.texts || {};
  var api = null;
  var bar = null, dialog = null, lastOpener = null, strict = false, live = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
  var mqDesktop = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: true };

  var params;
  try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
  var force = params ? (params.get('vd_cookie') || '') : '';

  /* ---------------------------------------------------------------- Hilfen */
  function ss(get, key, val) {
    try { if (get) return sessionStorage.getItem(key); sessionStorage.setItem(key, val); } catch (e) { return null; }
  }
  function getCookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function setCookie(n, v, days) {
    document.cookie = n + '=' + encodeURIComponent(v) + '; path=/; max-age=' + days * 86400 + '; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }
  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) e.setAttribute(k, attrs[k]);
    return e;
  }
  function gtag() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); }

  /* Text mit Platzhaltern {einstellungen} {datenschutz} {google} sicher aufbauen (kein innerHTML) */
  function richText(parent, text) {
    var parts = String(text || '').split(/(\{einstellungen\}|\{datenschutz\}|\{google\})/);
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (!p) continue;
      if (p === '{einstellungen}') {
        var b = el('button', 'vd-cc__link', { type: 'button', 'data-vd-cookie-settings': '', 'aria-haspopup': 'dialog' });
        b.textContent = T.settings || 'Cookie-Einstellungen';
        parent.appendChild(b);
      } else if (p === '{datenschutz}') {
        var a = el('a', 'vd-cc__link', { href: C.privacyUrl || '/policies/privacy-policy' });
        a.textContent = T.privacy || 'Datenschutz';
        parent.appendChild(a);
      } else if (p === '{google}') {
        var g = el('a', 'vd-cc__link', { href: 'https://policies.google.com/technologies/partner-sites', target: '_blank', rel: 'noopener' });
        g.textContent = T.google || 'So nutzt Google Daten';
        parent.appendChild(g);
      } else {
        parent.appendChild(document.createTextNode(p));
      }
    }
  }

  function announce(msg) {
    if (!live) {
      live = el('div', 'vd-cc__sr', { role: 'status', 'aria-live': 'polite' });
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }

  /* ---------------------------------------------------------------- Shopify API laden */
  function withApi(cb) {
    var done = false;
    function finish(x) { if (!done) { done = true; cb(x); } }
    var tries = 0;
    (function attempt() {
      var S = window.Shopify;
      if (S && S.customerPrivacy && typeof S.customerPrivacy.setTrackingConsent === 'function') return finish(S.customerPrivacy);
      if (S && typeof S.loadFeatures === 'function') {
        try {
          S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
            finish(!err && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null);
          });
        } catch (e) { finish(null); }
        setTimeout(function () { finish(window.Shopify && window.Shopify.customerPrivacy || null); }, 6000);
        return;
      }
      if (tries++ < 20) return setTimeout(attempt, 250); // max. 5 s
      finish(null);
    })();
  }

  function regionCode() {
    try { return String((api && api.getRegion && api.getRegion()) || '').toUpperCase(); } catch (e) { return ''; }
  }
  function isStrict() {
    if (force === 'eu') return true;
    if (force === 'ch') return false;
    if (C.rejectMode === 'all') return true;
    if (C.rejectMode === 'none') return false;
    var r = regionCode();
    if (!r) return true; // Region unbekannt -> vorsichtige Variante
    return STRICT.indexOf(r.slice(0, 2)) > -1;
  }

  /* Aktueller Stand (für die Häkchen im Dialog): nur echte Zustimmung = an, keine Vorauswahl */
  function currentChoice() {
    var c = { analytics: false, marketing: false, preferences: false };
    if (api && api.currentVisitorConsent) {
      try {
        var v = api.currentVisitorConsent() || {};
        c.analytics = v.analytics === 'yes';
        c.marketing = v.marketing === 'yes';
        c.preferences = v.preferences === 'yes';
      } catch (e) {}
    } else {
      var f = getCookie('vd_consent');
      if (f) { c.analytics = /a1/.test(f); c.marketing = /m1/.test(f); c.preferences = /p1/.test(f); }
    }
    return c;
  }

  /* Google Consent Mode (nur Seitenebene; das Pixel der App «Google & YouTube» steuert die App selbst) */
  function syncGoogle(c) {
    gtag('consent', 'update', {
      analytics_storage: c.analytics ? 'granted' : 'denied',
      ad_storage: c.marketing ? 'granted' : 'denied',
      ad_user_data: c.marketing ? 'granted' : 'denied',
      ad_personalization: 'denied', // kein Remarketing / keine personalisierte Werbung (Prüfbericht R3)
      personalization_storage: c.preferences ? 'granted' : 'denied'
    });
  }

  /* ---------------------------------------------------------------- Wahl speichern */
  var decided = false;
  function save(c, how) {
    decided = true;
    // Interne Geräte (Cookie vd_internal=1, gesetzt über ?vd_internal=1): nie Marketing an Google
    if (getCookie('vd_internal') === '1') c = { analytics: c.analytics, marketing: false, preferences: c.preferences };
    var payload = {
      analytics: !!c.analytics,
      marketing: !!c.marketing,
      preferences: !!c.preferences,
      sale_of_data: !!c.marketing
    };
    syncGoogle(c);
    hideBar();
    closeDialog();
    if (force) { announce(T.saved || 'Ihre Cookie-Einstellungen wurden gespeichert.'); return; } // Testmodus: nichts speichern
    if (api) {
      try {
        api.setTrackingConsent(payload, function () {
          try { document.dispatchEvent(new CustomEvent('vd:consent', { detail: { choice: payload, how: how } })); } catch (e) {}
        });
      } catch (e) {}
    } else {
      // Notfall (API nicht geladen): Wahl lokal merken, damit der Banner nicht bei jedem Seitenaufruf erscheint
      setCookie('vd_consent', 'a' + (c.analytics ? 1 : 0) + 'm' + (c.marketing ? 1 : 0) + 'p' + (c.preferences ? 1 : 0), 365);
    }
    announce(T.saved || 'Ihre Cookie-Einstellungen wurden gespeichert.');
  }

  /* ---------------------------------------------------------------- Leiste */
  function buildBar() {
    bar = el('section', 'vd-cc' + (strict ? ' vd-cc--strict' : ''), {
      id: 'vd-cc', 'aria-label': T.region || 'Cookie-Hinweis', 'data-vd-cc': ''
    });
    var inner = el('div', 'vd-cc__inner');
    var text = el('p', 'vd-cc__text', { id: 'vd-cc-text' });
    var full = el('span', 'vd-cc__full');
    var short = el('span', 'vd-cc__short');
    richText(full, strict ? T.textStrict : T.text);
    richText(short, strict ? (T.textStrictMobile || T.textStrict) : (T.textMobile || T.text));
    text.appendChild(full);
    text.appendChild(short);

    var actions = el('div', 'vd-cc__actions');
    var implicit = isImplicit();
    if (strict) {
      var rej = el('button', 'vd-cc__btn vd-cc__btn--reject', { type: 'button', 'data-vd-cc-reject': '' });
      rej.textContent = T.reject || 'Nur notwendige';
      actions.appendChild(rej);
    }
    var acc = el('button', 'vd-cc__btn vd-cc__btn--accept', { type: 'button', 'data-vd-cc-accept': '' });
    acc.textContent = T.accept || 'Alle Cookies akzeptieren';
    if (!implicit) actions.appendChild(acc);

    inner.appendChild(text);
    if (!implicit) inner.appendChild(actions);

    if (C.closeX && !implicit) {
      var x = el('button', 'vd-cc__close', { type: 'button', 'aria-label': T.closeLabel || 'Hinweis schliessen (ohne Einwilligung)', title: T.closeLabel || 'Hinweis schliessen (ohne Einwilligung)' });
      x.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      x.addEventListener('click', function () { ss(false, 'vd_cc_hidden', '1'); hideBar(); });
      inner.appendChild(x);
    }
    bar.appendChild(inner);

    acc.addEventListener('click', function () { save({ analytics: true, marketing: true, preferences: true }, 'accept_all'); });
    if (strict) actions.querySelector('[data-vd-cc-reject]').addEventListener('click', function () {
      save({ analytics: false, marketing: false, preferences: false }, 'reject_all');
    });

    // Früh in der Tab-Reihenfolge: direkt nach dem «Zum Inhalt springen»-Link
    var skip = document.querySelector('.skip-to-content-link');
    if (skip && skip.parentNode === document.body) document.body.insertBefore(bar, skip.nextSibling);
    else document.body.insertBefore(bar, document.body.firstChild);
  }

  function showBar() {
    if (!bar) buildBar();
    syncOffset();
    bar.hidden = false;
    document.documentElement.classList.add('vd-cc-open');
    if (reduceMotion) bar.classList.add('is-visible');
    else requestAnimationFrame(function () { requestAnimationFrame(function () { bar.classList.add('is-visible'); }); });
  }
  function hideBar() {
    if (!bar) return;
    bar.classList.remove('is-visible');
    document.documentElement.classList.remove('vd-cc-open');
    var b = bar;
    var hasFocus = b.contains(document.activeElement);
    setTimeout(function () { b.hidden = true; }, reduceMotion ? 0 : 350);
    if (hasFocus) { var main = document.getElementById('MainContent'); if (main) main.focus({ preventScroll: true }); }
  }

  /* Handy/Tablet: Leiste sitzt ÜBER der Sticky-Kaufleiste (.vd-sticky-atc), verdeckt sie nie */
  function syncOffset() {
    if (!bar) return;
    var off = 0;
    var s = document.querySelector('.vd-sticky-atc.is-visible');
    if (s && !mqDesktop.matches) off = Math.round(s.getBoundingClientRect().height);
    bar.style.setProperty('--vd-cc-offset', off + 'px');
  }
  function watchSticky() {
    var s = document.querySelector('.vd-sticky-atc');
    if (!s) return;
    if ('MutationObserver' in window) new MutationObserver(syncOffset).observe(s, { attributes: true, attributeFilter: ['class'] });
    if ('ResizeObserver' in window) new ResizeObserver(syncOffset).observe(s);
    window.addEventListener('resize', syncOffset);
  }

  /* ---------------------------------------------------------------- Einstellungen (Dialog) */
  var CATS = [
    { key: 'necessary', locked: true },
    { key: 'analytics' },
    { key: 'marketing' },
    { key: 'preferences' }
  ];

  function buildDialog() {
    var hasNative = typeof HTMLDialogElement === 'function';
    dialog = el(hasNative ? 'dialog' : 'div', 'vd-cc-dialog', { 'aria-labelledby': 'vd-cc-dialog-title', id: 'vd-cc-dialog' });
    if (!hasNative) { dialog.setAttribute('role', 'dialog'); dialog.setAttribute('aria-modal', 'true'); dialog.hidden = true; }

    var form = el('form', 'vd-cc-dialog__form', { method: 'dialog' });
    var head = el('div', 'vd-cc-dialog__head');
    var h = el('h2', 'vd-cc-dialog__title', { id: 'vd-cc-dialog-title' });
    h.textContent = T.title || 'Cookie-Einstellungen';
    var x = el('button', 'vd-cc-dialog__x', { type: 'button', 'aria-label': T.closeDialog || 'Einstellungen schliessen' });
    x.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    x.addEventListener('click', closeDialog);
    head.appendChild(h);
    head.appendChild(x);

    var intro = el('p', 'vd-cc-dialog__intro');
    richText(intro, T.intro);

    var list = el('ul', 'vd-cc-dialog__list', { role: 'list' });
    var cats = T.cats || {};
    for (var i = 0; i < CATS.length; i++) {
      var c = CATS[i];
      var info = cats[c.key] || {};
      var li = el('li', 'vd-cc-cat');
      var id = 'vd-cc-cat-' + c.key;
      var row = el('div', 'vd-cc-cat__row');
      var lab = el('label', 'vd-cc-cat__label', { 'for': id });
      lab.textContent = info.label || c.key;
      var sw = el('span', 'vd-cc-switch');
      var input = el('input', 'vd-cc-switch__input', { type: 'checkbox', id: id, role: 'switch', name: c.key, 'aria-describedby': id + '-desc' });
      if (c.locked) { input.checked = true; input.disabled = true; input.setAttribute('aria-disabled', 'true'); }
      var track = el('span', 'vd-cc-switch__track', { 'aria-hidden': 'true' });
      sw.appendChild(input);
      sw.appendChild(track);
      row.appendChild(lab);
      if (c.locked) {
        var always = el('span', 'vd-cc-cat__always');
        always.textContent = T.always || 'Immer aktiv';
        row.appendChild(always);
      }
      row.appendChild(sw);
      var desc = el('p', 'vd-cc-cat__desc', { id: id + '-desc' });
      richText(desc, info.desc);
      li.appendChild(row);
      li.appendChild(desc);
      list.appendChild(li);
    }

    var actions = el('div', 'vd-cc-dialog__actions');
    var saveBtn = el('button', 'vd-cc__btn vd-cc__btn--outline', { type: 'button', 'data-vd-cc-save': '' });
    saveBtn.textContent = T.save || 'Auswahl speichern';
    var all = el('button', 'vd-cc__btn vd-cc__btn--accept', { type: 'button' });
    all.textContent = T.accept || 'Alle Cookies akzeptieren';
    actions.appendChild(saveBtn);
    if (strict) {
      var rej = el('button', 'vd-cc__btn vd-cc__btn--outline', { type: 'button' });
      rej.textContent = T.reject || 'Nur notwendige';
      rej.addEventListener('click', function () { save({ analytics: false, marketing: false, preferences: false }, 'reject_all'); });
      actions.appendChild(rej);
    }
    actions.appendChild(all);

    saveBtn.addEventListener('click', function () {
      save({
        analytics: dialog.querySelector('[name="analytics"]').checked,
        marketing: dialog.querySelector('[name="marketing"]').checked,
        preferences: dialog.querySelector('[name="preferences"]').checked
      }, 'custom');
    });
    all.addEventListener('click', function () { save({ analytics: true, marketing: true, preferences: true }, 'accept_all'); });

    form.appendChild(head);
    form.appendChild(intro);
    form.appendChild(list);
    form.appendChild(actions);
    dialog.appendChild(form);

    // Klick auf den abgedunkelten Hintergrund schliesst (ohne zu speichern)
    dialog.addEventListener('click', function (e) { if (e.target === dialog) closeDialog(); });
    dialog.addEventListener('close', afterClose);
    dialog.addEventListener('cancel', function () { /* Esc: schliessen ohne speichern */ });
    if (!hasNative) document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dialog.hidden) closeDialog(); });
    document.body.appendChild(dialog);
  }

  function openDialog(opener) {
    if (!dialog) buildDialog();
    lastOpener = opener || document.activeElement;
    var c = currentChoice();
    dialog.querySelector('[name="analytics"]').checked = c.analytics;
    dialog.querySelector('[name="marketing"]').checked = c.marketing;
    dialog.querySelector('[name="preferences"]').checked = c.preferences;
    document.documentElement.classList.add('vd-cc-dialog-open');
    if (dialog.showModal) { if (!dialog.open) dialog.showModal(); }
    else { dialog.hidden = false; }
    var first = dialog.querySelector('input:not([disabled])');
    if (first) first.focus();
  }
  function closeDialog() {
    if (!dialog) return;
    if (dialog.close && dialog.open) dialog.close();
    else if (!dialog.close && !dialog.hidden) { dialog.hidden = true; afterClose(); }
  }
  function afterClose() {
    document.documentElement.classList.remove('vd-cc-dialog-open');
    var target = lastOpener;
    lastOpener = null;
    if (target && document.contains(target) && target.offsetParent !== null) { try { target.focus(); } catch (e) {} }
  }

  /* ---------------------------------------------------------------- Zustimmung per Klick (Schweiz, Entscheid Aleksandar 16.10.2026)
   * Ausserhalb der strengen Regionen gibt es keinen Akzeptieren-Knopf: Der erste Klick irgendwo auf der Seite
   * (ausser auf den Hinweis selbst, die Einstellungen oder die Altersabfrage) gilt als Zustimmung zu allen Kategorien.
   * Ändern jederzeit über «Cookie-Einstellungen» (Fusszeile, Datenschutzerklärung). */
  function isImplicit() { return !strict && C.implicit !== false; }
  function armImplicit() {
    if (!isImplicit()) return;
    function onClick(e) {
      if (decided || !bar || bar.hidden) return;
      var t = e.target;
      if (t && t.closest && (t.closest('#vd-cc') || t.closest('#vd-cc-dialog') || t.closest(RESHOW) || t.closest('#vd-age-gate'))) return;
      window.removeEventListener('click', onClick, true);
      save({ analytics: true, marketing: true, preferences: true }, 'implicit_click');
    }
    window.addEventListener('click', onClick, true);
  }

  /* ---------------------------------------------------------------- Link in der Fusszeile */
  var RESHOW = 'a[href*="#shopifyReshowConsentBanner"], a[href="#vd-cookie-einstellungen"], [data-vd-cookie-settings]';
  // Capture auf window: läuft vor allen anderen Listenern (auch vor Shopifys eigenem Banner-Skript)
  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(RESHOW) : null;
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openDialog(t);
  }, true);

  function ensureFooterLink() {
    if (!C.footerLink) return;
    if (document.querySelector('footer a[href*="#shopifyReshowConsentBanner"], footer [data-vd-cookie-settings], .footer a[href*="#shopifyReshowConsentBanner"]')) return;
    var priv = document.querySelector('footer a[href*="/policies/privacy-policy"], .footer a[href*="/policies/privacy-policy"]');
    if (!priv) return;
    var li = priv.closest('li');
    if (!li || !li.parentNode) return;
    var copy = li.cloneNode(false);
    var a = el('a', priv.className, { href: '#vd-cookie-einstellungen', 'data-vd-cookie-settings': '', 'aria-haspopup': 'dialog' });
    a.textContent = T.settings || 'Cookie-Einstellungen';
    copy.appendChild(a);
    li.parentNode.appendChild(copy);
  }

  /* ---------------------------------------------------------------- Start */
  function whenAgeGateClosed(fn) {
    var gate = document.getElementById('vd-age-gate');
    if (!gate || !gate.classList.contains('is-visible') || !('MutationObserver' in window)) return fn();
    var mo = new MutationObserver(function () {
      if (!gate.classList.contains('is-visible')) { mo.disconnect(); setTimeout(fn, 250); }
    });
    mo.observe(gate, { attributes: true, attributeFilter: ['class'] });
  }

  function start() {
    ensureFooterLink();
    watchSticky();
    withApi(function (cp) {
      api = cp;
      strict = isStrict();
      var should;
      if (force === 'show' || force === 'ch' || force === 'eu' || force === 'prefs') should = true;
      else if (api && api.shouldShowBanner) { try { should = !!api.shouldShowBanner(); } catch (e) { should = true; } }
      else should = !getCookie('vd_consent');
      // Shopify meldet ohne eigenen Banner weiterhin «anzeigen», auch nach einer Wahl → schon entschieden = nicht mehr zeigen
      if (should && !force && api && api.currentVisitorConsent) {
        try { var cv = api.currentVisitorConsent() || {}; if (cv.analytics || cv.marketing || cv.preferences) should = false; } catch (e) {}
      }

      if (!should && api) {
        // Schon entschieden oder Region ohne Banner: Google-Status auf Seitenebene angleichen
        try {
          syncGoogle({
            analytics: api.analyticsProcessingAllowed(),
            marketing: api.marketingAllowed(),
            preferences: api.preferencesProcessingAllowed()
          });
        } catch (e) {}
      }

      document.documentElement.setAttribute('data-vd-cc-variant', strict ? 'strict' : 'standard');
      if (force === 'prefs') { openDialog(null); return; }
      if (/#(shopifyReshowConsentBanner|vd-cookie-einstellungen)$/.test(location.hash)) openDialog(null);
      if (should && (ss(true, 'vd_cc_hidden') !== '1' || force)) whenAgeGateClosed(function () { showBar(); armImplicit(); });
    });
  }

  // kleine Schnittstelle für andere Skripte/Tests
  window.vdCookieBanner = {
    open: function () { openDialog(null); },
    show: function () { showBar(); },
    variant: function () { return strict ? 'strict' : 'standard'; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
